import React, { JSXElementConstructor, ReactElement } from "react";
import { NoDataComponent } from "../../../../../ds";
import { MorePartsDataResponse, MorePartsPageFactory } from "../../../business";
import { MorePartsContent } from "../screens";

export class MorePartsPageFactoryImpl implements MorePartsPageFactory {
    create(morePartsData: MorePartsDataResponse | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (morePartsData?.success && morePartsData.success === true) {
            return <MorePartsContent data={morePartsData.response} />
        }
        return <NoDataComponent />
    }
}